import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralService } from '../services/general.service';
import { TEST_CATEGORIES, TESTS, Items } from './TestsData';
import { TestCategory } from './CategoryModel';
import { ItemsModel } from './ItemsModel';
import { Test } from './TestModel';
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-TestResults',
  templateUrl: './TestResults.component.html',
  styleUrls: ['./TestResults.component.scss'],
  providers: [DatePipe] // Add DatePipe as a provider

})
export class TestResultsComponent implements OnInit {
  AddTestResultForm: FormGroup;
  UserInfo: any;
  ClientId: any;
  AllBranchs: any;
  categories: TestCategory[] = TEST_CATEGORIES;
  items: ItemsModel[] = Items;
  tests: Test[] = TESTS;
  filteredTests: Test[] = [];
  selectedCategoryId: number | null = null;
  result = [{
    value: 'PASS',
    name: 'PASS'
  },
  {
    value: 'FAIl',
    name: 'FAIl'
  }
  ]
  constructor(private _formBuilder: FormBuilder,private datePipe: DatePipe, public GeneralService: GeneralService
  ) {

    this.UserInfo = JSON.parse(localStorage.getItem('currentuser'));
    this.ClientId = this.UserInfo.clientid;
  }
  get fc() {
    return this.AddTestResultForm.controls;
  }

  ngOnInit() {
    this.initForm()
    this.GetAllBranchs()
  }
  initForm() {
    const formattedDate = this.datePipe.transform(Date.now(), 'yyyy-MM-dd'); // Format current date

    this.AddTestResultForm = this._formBuilder.group({
      ItemId: ['', Validators.required],
      ItemName: [''],
      CategoryId: ['', Validators.required],
      CategoryName: [''],
      TestId: ['', Validators.required],
      TestName: [''],
      Result: [[], Validators.required],
      Notes: [''],
      DateResult: ['', Validators.required],
      Branch: ['', Validators.required],
      UserId: [this.UserInfo.id],
      ClientId: [this.ClientId],
      CreateDate: [formattedDate],
      Month: [''],
      Year: [''],
    });
    this.AddTestResultForm.get('ItemId')?.valueChanges.subscribe((itemId) => {
      const selectedItem = this.items.find(item => item.id === itemId); // Find the selected item
      this.AddTestResultForm.patchValue({ ItemName: selectedItem ? selectedItem.name : '' }); // Update the ItemName
    });

    this.AddTestResultForm.get('CategoryId')?.valueChanges.subscribe((CategoryId) => {
      const selectedCategory = this.categories.find(Category => Category.id === CategoryId); // Find the selected item
      this.AddTestResultForm.patchValue({ CategoryName: selectedCategory ? selectedCategory.name : '' }); // Update the ItemName
    });

    this.AddTestResultForm.get('TestId')?.valueChanges.subscribe((TestId) => {
      const selectedTest = this.tests.find(test => test.id === TestId); // Find the selected item
      this.AddTestResultForm.patchValue({ TestName: selectedTest ? selectedTest.name : '' }); // Update the ItemName
    });


    this.AddTestResultForm.get('DateResult')?.valueChanges.subscribe((date) => {
      if (date) {
        const formattedDate = this.datePipe.transform(date, 'yyyy-MM-dd'); // Format the date
        const dateObj = new Date(formattedDate);
        const month = dateObj.getMonth() + 1;
        const year = dateObj.getFullYear();
         console.log(month);
         console.log(year);
        this.AddTestResultForm.patchValue({ DateResult: formattedDate }, { emitEvent: false });
this.AddTestResultForm.patchValue({ Month: month }, { emitEvent: false });
this.AddTestResultForm.patchValue({ Year: year }, { emitEvent: false });
      }
    });
  }
  GetTestsByCatId(categoryId) {
    console.log(categoryId)
    this.AddTestResultForm.get('TestId').reset()
    this.filteredTests = this.tests.filter(test => test.categoryId === categoryId);
  }

  GetAllBranchs() {
    this.GeneralService.getBranchByClientId(this.ClientId).then(res => {
      this.AllBranchs = res;
    })
  }
  GetAllItems() {
    this.GeneralService.getBranchByClientId(this.ClientId).then(res => {
      this.AllBranchs = res;
      console.log(this.AllBranchs)
    })
  }
  InsertTestResult() {
    console.log(this.AddTestResultForm.value)
    this.GeneralService.addTestLab(this.AddTestResultForm.value).then(res => {
      Swal.fire({
        title: "Success",
        text: "Your Test has been Added.",
        icon: "success"
      }); 
      // this.AddTestResultForm.reset()
      this.AddTestResultForm.reset({
        ClientId: this.ClientId,
        UserId: this.UserInfo.id,
        CreateDate: this.AddTestResultForm.get('CreateDate')?.value, // Keep the original formatted date
      });
    },
      (err) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err.error,
        });
      })
  }

  Submit() {
    if (this.AddTestResultForm.status == "VALID") {
      this.InsertTestResult()
    }
    else {
      this.AddTestResultForm.markAllAsTouched();
    }
  }
}
